import { QueryClient, type QueryClientConfig } from "@tanstack/react-query";

// Set up default query client configuration
const defaultQueryClientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 1000 * 60 * 5, // 5 minutes
      refetchOnWindowFocus: false,
    },
    mutations: { retry: 1 },
  },
};

/**
 * Create a QueryClient with default configuration
 * or merge config with provided options
 */
export function createQueryClient(config: QueryClientConfig = {}) {
  return new QueryClient({ ...defaultQueryClientConfig, ...config });
}

// Create a default query client
export const reactQueryClient = createQueryClient();
